export const STATUS_PENDING = "PENDING";
export const STATUS_SUCCESS = "SUCCESS";
export const STATUS_FAILED = "FAILED";
export const ACTION_CREATE = "CREATE";
export const ACTION_UPDATE = "UPDATE";
export const ACTION_DELETE = "DELETE";
export const ACTION_SUBSCRIBED = "SUBSCRIBED";
export const ACTION_EMAILED = "EMAILED";

export const SERVICE_MODE_TEST = "test";
export const SERVICE_MODE_PROD = "prod";

export const SERVICE_TYPE_QUICKBOOKS = "QUICKBOOKS";
export const SERVICE_TYPE_NOVOXPRESS = "NOVOXPRESS";
export const SERVICE_TYPE_ELIXIOCONNECT = "ELIXIOCONNECT";
export const SERVICE_TYPE_NUVEI = "NUVEI";
export const SERVICE_TYPE_ESIGN = "ESIGN";
export const SERVICE_TYPE_PANDAPAY = "PANDAPAY";
export const SERVICE_TYPE_GHL = "GHL";

export const SERVICES_MODES = [
  { code: SERVICE_MODE_TEST, label: "Test" },
  { code: SERVICE_MODE_PROD, label: "Prod" },
];

export const SERVICES_LOGOS = {
  QUICKBOOKS: "/img/logos/quickbooks.webp",
  NOVOXPRESS: "/img/logos/novoxpress.svg",
  ELIXIOCONNECT: "/img/logos/elixioconnect.svg",
  NUVEI: "/img/logos/nuvei.png",
  ESIGN: "/img/logos/esign.svg",
  PANDAPAY: "/img/logos/pandapay.jpg",
  GHL: "/img/logos/ghl.svg",
};

export const SERVICES_TYPES = [
  {
    code: SERVICE_TYPE_QUICKBOOKS,
    logo: SERVICES_LOGOS.QUICKBOOKS,
    label: "QuickBooks",
    fields: [
      {
        key: "client_id",
        label: "client_id",
        type: "text",
      },
      {
        key: "client_secret",
        label: "client_secret",
        type: "text",
      },
      {
        key: "callback_url",
        label: "callback_url",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_NOVOXPRESS,
    logo: SERVICES_LOGOS.NOVOXPRESS,
    label: "NovoXpress",
    fields: [
      {
        key: "api_token",
        label: "Jeton API",
        type: "text",
      },
      {
        key: "callback_url",
        label: "Callback URL",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_ELIXIOCONNECT,
    logo: SERVICES_LOGOS.ELIXIOCONNECT,
    label: "Elixio Connect",
    fields: [
      {
        key: "callback_url",
        label: "Callback URL",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_NUVEI,
    logo: SERVICES_LOGOS.NUVEI,
    label: "Nuvei",
    fields: [
      {
        key: "merchant_id",
        label: "ID Marchand",
        type: "text",
      },
      {
        key: "merchant_site_id",
        label: "ID Site Marchand",
        type: "text",
      },
      {
        key: "merchant_secret_key",
        label: "Clé Secrète",
        type: "text",
      },
      {
        key: "callback_url",
        label: "Callback URL",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_ESIGN,
    logo: SERVICES_LOGOS.ESIGN,
    label: "E-sign",
    fields: [
      {
        key: "onespan_api_key",
        label: "Clé API OneSpan (optionnel)",
        type: "text",
      },
      {
        key: "callback_url",
        label: "Callback URL",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_PANDAPAY,
    logo: SERVICES_LOGOS.PANDAPAY,
    label: "PandaPay",
    fields: [
      {
        key: "merchant_id",
        label: "ID Marchand",
        type: "text",
      },
      {
        key: "merchant_secret_key",
        label: "Clé API",
        type: "text",
      },
      {
        key: "callback_url",
        label: "Callback URL",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
  {
    code: SERVICE_TYPE_GHL,
    logo: SERVICES_LOGOS.GHL,
    label: "GoHighLevel",
    fields: [
      {
        key: "auth_type",
        label: "Type d'authentification",
        type: "select",
        options: [
          { value: "api_key", label: "Clé API" },
          { value: "oauth2", label: "OAuth 2.0" },
        ],
        default: "api_key",
      },
      {
        key: "location_id",
        label: "ID de localisation",
        type: "text",
        dependsOn: { auth_type: "api_key" },
      },
      {
        key: "api_key",
        label: "Clé API",
        type: "password",
        dependsOn: { auth_type: "api_key" },
      },
      {
        key: "client_id",
        label: "ID Client",
        type: "text",
        dependsOn: { auth_type: "oauth2" },
      },
      {
        key: "client_secret",
        label: "Secret Client",
        type: "password",
        dependsOn: { auth_type: "oauth2" },
      },
      {
        key: "callback_url",
        label: "callback_url",
        type: "text",
        description: "Callback URL pour Elixio Connect",
      },
    ],
  },
];
